import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import BestEarplugLawyersWrapper from "@components/layouts/bestearpluglawyersWrapper";
import MainBanner from "@components/bestearpluglawyers/mainBanner";

const Lawsuit = dynamic(() => import("@components/bestearpluglawyers/lawsuit"));
const About = dynamic(() => import("@components/bestearpluglawyers/about"));
const Intro = dynamic(() => import("@components/bestearpluglawyers/intro"));
const Defect = dynamic(() => import("@components/bestearpluglawyers/defect"));

const OffersList = dynamic(() => import("@components/shared/offersList"));

export default function BestEarplugLawyersHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <BestEarplugLawyersWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <About />
            <Intro />
            <Defect />
            <Lawsuit />
        </BestEarplugLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
